
if(!window.Vue) {
	window.Vue = require('vue');
}

Vue.component('updateProfile', require('./components/update-profile.vue'));
Vue.component('updatePin', require('./components/update-pin.vue'));
Vue.component('updatePassword', require('./components/update-password.vue'));
Vue.component('register', require('./components/register.vue'));
Vue.component('createProfile', require('./components/create-profile.vue'));
Vue.component('login', require('./components/login.vue'));
Vue.component('updatePasswordPin', require('./components/update-password-pin.vue'));
Vue.component('lockUnlock', require('./components/lock-unlock.vue'));


// WEBPACK FOOTER //
// ./resources/assets/js/user.js